import { Component, OnInit, OnDestroy } from '@angular/core';
import { RequestService } from '@fuse/services/request/request.service';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { fuseAnimations } from '@fuse/animations';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { RequestFormDialogComponent } from './request-form/request-form.component';

@Component({
    selector: 'request-management',
    templateUrl: './request-management.component.html',
    styleUrls: ['./request-management.component.scss'],
    animations: fuseAnimations
})
export class RequestManagementComponent implements OnInit, OnDestroy {

    private _unsubscribeAll: Subject<any>;
    
    dialogRef: any;
    searchInput: FormControl;
    lang = 'sr';

    constructor(
        private _requestService: RequestService,
        private _translate: TranslateService,
        private _matDialog: MatDialog,
        private _translationLoader: FuseTranslationLoaderService,
    ) {
        this._unsubscribeAll = new Subject();
        this.searchInput = new FormControl('');
    }

    getTranslations(): void {
        this._translationLoader.getLastLang()
        .then(response => {
            this.lang = response['code'];
            this._translationLoader.getTranslations(this.lang, '23');
            console.log(this.lang);
        })
        .catch(err => Promise.reject(err))
        .then(() => {
        }, err => {
        });
    }

    newRequest(): void {
        console.log('Add request');

        this.dialogRef = this._matDialog.open(RequestFormDialogComponent, {
            panelClass: 'request-form-dialog',
            data: {
                action: 'new',
            }
        });

        this.dialogRef.afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                // do nothing
            });
    }

    ngOnInit(): void {
        // this._requestService.getAllNotifications().subscribe((data) => {
        //     console.log(data);
        // });
        this.getTranslations();
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.getTranslations();
            });
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
